exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-link-num[data-v-d79d3f2a] {\r\n  font-size: 16px;\r\n  color: #46a6ff;\n}\n.card-panel-num[data-v-d79d3f2a] {\r\n  font-size: 16px;\n}\n.demo-dynamic[data-v-d79d3f2a]{\r\n  background-color: #f6f6f6;\r\n  padding-top: 5px;\r\n  padding-bottom: 5px;\n}\n[data-v-d79d3f2a] .vue-treeselect__control,[data-v-d79d3f2a] .vue-treeselect__placeholder,[data-v-d79d3f2a] .vue-treeselect__single-value {\r\n  height: 30px;\r\n  line-height: 30px;\n}\r\n", ""]);

// exports
